export type CapacityBasis = 'team_member' | 'resource';
export type BookingChoice = 'specific_person' | 'business_assigned';
export type ManagementStyle = 'individual_logins' | 'centralized';

export type OnboardingModeDecision = {
  operatingMode: 'team' | 'front_desk';
  bookingChoice: BookingChoice;
  managementStyle: ManagementStyle;
  showEmployeePicker: boolean;
};

export const resolveOnboardingMode = (
  capacityBasis: CapacityBasis,
  bookingChoice?: BookingChoice,
  managementStyle?: ManagementStyle,
): OnboardingModeDecision => {
  if (capacityBasis === 'resource') {
    return {
      operatingMode: 'front_desk',
      bookingChoice: 'business_assigned',
      managementStyle: 'centralized',
      showEmployeePicker: false,
    };
  }

  if (bookingChoice === 'specific_person') {
    return {
      operatingMode: 'team',
      bookingChoice,
      managementStyle: 'individual_logins',
      showEmployeePicker: true,
    };
  }

  if (bookingChoice === 'business_assigned' && managementStyle) {
    return {
      operatingMode: managementStyle === 'individual_logins' ? 'team' : 'front_desk',
      bookingChoice,
      managementStyle,
      showEmployeePicker: false,
    };
  }

  throw new Error('Complete the scheduling questions before choosing a setup.');
};
